/* eslint-disable import/prefer-default-export */
export const GET_SCHEDULE_URL = `https://api.tizeti.com/api/v1/users/scheduled/1`;
